import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const DOMPaymentSettingsComponent = ({ selectDOMSettings, handleInnerFormChange }: any) => {

    return (
        <>
        <AccordionContainer
            child={
            <div className=' grid md:grid-cols-3 lg:grid-cols-3 gap-3'>
                  <InputContainer
                    label="Online"
                    name="IsDirectShipmentEnabled"
                    onValueChange={(event: any) => {
                    handleInnerFormChange(
                        event,
                        'ShippingSettings.IsDirectShipmentEnabled',
                        selectDOMSettings?.ShippingSettings
                    )
                    }}
                    type="checkbox"
                    value={selectDOMSettings?.ShippingSettings?.IsDirectShipmentEnabled}
                />
                <InputContainer
                    label="Cash"
                    name="IsDirectShipmentEnabled"
                    onValueChange={(event: any) => {
                    handleInnerFormChange(
                        event,
                        'ShippingSettings.IsDirectShipmentEnabled',
                        selectDOMSettings?.ShippingSettings
                    )
                    }}
                    type="checkbox"
                    value={selectDOMSettings?.ShippingSettings?.IsDirectShipmentEnabled}
                />
                <InputContainer
                    label="Wallet"
                    name="IsDirectShipmentEnabled"
                    onValueChange={(event: any) => {
                    handleInnerFormChange(
                        event,
                        'ShippingSettings.IsDirectShipmentEnabled',
                        selectDOMSettings?.ShippingSettings
                    )
                    }}
                    type="checkbox"
                    value={selectDOMSettings?.ShippingSettings?.IsDirectShipmentEnabled}
                />
                <InputContainer
                    label="Pay By Link"
                    name="IsDirectShipmentEnabled"
                    onValueChange={(event: any) => {
                    handleInnerFormChange(
                        event,
                        'ShippingSettings.IsDirectShipmentEnabled',
                        selectDOMSettings?.ShippingSettings
                    )
                    }}
                    type="checkbox"
                    value={selectDOMSettings?.ShippingSettings?.IsDirectShipmentEnabled}
                />
                <InputContainer
                    label="Allow Online Payment For COD"
                    name="IsDirectShipmentEnabled"
                    onValueChange={(event: any) => {
                    handleInnerFormChange(
                        event,
                        'ShippingSettings.IsDirectShipmentEnabled',
                        selectDOMSettings?.ShippingSettings
                    )
                    }}
                    type="checkbox"
                    value={selectDOMSettings?.ShippingSettings?.IsDirectShipmentEnabled}
                />    
            </div>
            }
        expandedPanel="Payment Settings"
        headerTitle="Payment Settings"
        />
        </>
  )
}
export default DOMPaymentSettingsComponent;
